module.exports = __webpack_public_path__ + "static/media/酒店信息_11.ce191460.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hotel/image/酒店信息_11.png
// module id = 1201
// module chunks = 0